import ApiService from "@/services/api.service";

const CollectService = {
	depCollectService(departmentId,data) {
		return ApiService.post(`/item/search/wrappedItems/${departmentId}`,data);
	},
	created(departmentId,data){
		return ApiService.post(`/wh-collect-items/collect-items/${departmentId}`,data)
	},
	getItem(data){
		return ApiService.post(`/wh-collect-items/list-search`,data)
	}
}
export default CollectService
